import React from 'react'
import meritCar1 from '../../../assets/imgs/host/merit01.png'
import meritCar1Dimension from '../../../assets/imgs/host/merit01.png?size'
import meritCar2 from '../../../assets/imgs/host/merit02.png'
import meritCar2Dimension from '../../../assets/imgs/host/merit02.png?size'
import meritCar3 from '../../../assets/imgs/host/merit03.png'
import meritCar3Dimension from '../../../assets/imgs/host/merit03.png?size'
import ResponsiveImg from '../../common/ResponsiveImg'
import styles from './Merit.scss'

const Merit = () => <> <div className={styles.containerBack}>
  <div className={styles.space120}/>
    <div>
      <div className={['align-items-center', styles.titleRow, styles.container].join(' ')}>
        <h2 className={['d-inline', styles.title].join(' ')}><span className={styles.otherFont}>Carstay</span>のホストになる
        <br className='d-block d-sm-none'/>
        メリット</h2>
        <div className={styles.spaceSp48}/>
      </div>
      <div className={['d-md-flex', styles.containerContent].join(' ')}>
        <div className={[styles.voiceRow].join(' ')}>
          <div className={[styles.image].join(' ')}>
            <ResponsiveImg
              url={meritCar1}
              caption="meritCar1"
              srcSet={meritCar1}
              dimension={meritCar1Dimension}
            />
         </div>
         <div className="my-md-2">
            <h3 className={['pb-2', styles.subTitle, styles.lh30].join(' ')}>店舗・施設への集客効果が期待できる</h3>
            <p className={['mb-0', styles.text, styles.mt10].join(' ')}>
              飲食店、日帰り温泉、レジャー、公共施設の駐車場なども車1台分のスペースから車中泊スポットとして登録できるため、新規顧客の獲得や、車中泊スポット以外の附帯売上（食事、お風呂、お土産、サービス利用等）を期待できます。
            </p>
         </div>
        </div>
        <div className={[styles.voiceRow, styles.space65].join(' ')}>
          <div className={[styles.image].join(' ')}>
            <ResponsiveImg
              url={meritCar2}
              caption="meritCar2"
              srcSet={meritCar2}
              dimension={meritCar2Dimension}
            />
          </div>
          <div className="my-md-2">
            <h3 className={['pb-2', styles.subTitle].join(' ')}>地域の観光活性化につながる</h3>
            <p className={['mb-0 d-md-block d-none', styles.text].join(' ')}>
              空き地や駐車場、利用のない別荘など遊休地を車中泊スポット化すると、音楽フェスやイベント時の宿泊施設不足解消、観光客と地域の人々の交流が生まれることによる観光活性化、土地・施設の維持管理や防犯対策に活用できます。地域、自治体で連携をご希望の方はご相談ください。
            </p>
            <p className={['mb-0 d-block d-md-none', styles.text].join(' ')}>
              相互レビューや予約リクエストのシステムを用いて、ゲストと健全な関係を築くことができます。Carstay主催のホルダーコミュニティで、キャンピングカーの車両オーナー同士での交流ができます。
            </p>
          </div>
        </div>
        <div className={[styles.voiceRow].join(' ')}>
          <div className={[styles.image].join(' ')}>
            <ResponsiveImg
              url={meritCar3}
              caption="meritCar3"
              srcSet={meritCar3}
              dimension={meritCar3Dimension}
            />
          </div>
          <div className="my-md-2">
            <h3 className={['pb-2', styles.subTitle].join(' ')}>初期費用・掲載料0円で始められる</h3>
            <p className={['mb-0', styles.text].join(' ')}>
            ゲストの利用があった際の決済手数料はいただきますが、初期費用・掲載料は無料です。日本全国280箇所の車中泊スポット・キャンプ場の掲載数を誇る Carstayに掲載することで、お金をかけずに集客可能・収益化が見込めます。
            </p>
          </div>
        </div>
      </div>
    </div>
    <div className={styles.space90}/>
 </div>
 </>
Merit.displayName = 'Merit'
export default Merit
